import { useTheme } from 'styled-components/macro';

import { Image } from './styles';

export const RoomDefaultCustom = () => {
  const theme = useTheme();

  return <Image alt="" src={theme.customDefaultRoomUrl} />;
};
